import styled from "styled-components";

export const PackageCard = styled.div`
  background: #ffffff;
  box-shadow: 0px 1px 4px #15223214;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
`;

export const PackageHeader = styled.div`
  background: linear-gradient(135deg, #fd665e 0%, #ff8a80 100%);
  color: white;
  padding: 20px 24px;
  border-radius: 16px;
  margin: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  box-shadow: 0 8px 32px rgba(253, 102, 94, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transform: translate(30px, -30px);
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    transform: translate(-20px, 20px);
  }
`;

export const PackageTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.5px;

  &::before {
    content: "✈️";
    margin-right: 12px;
    font-size: 22px;
  }
`;

export const PackageInfo = styled.div`
  font-size: 15px;
  margin-top: 8px;
  opacity: 0.95;
  font-weight: 500;
  position: relative;
  z-index: 1;
  line-height: 1.4;
  max-width: 85%;
`;

export const PackageContent = styled.div`
  padding: 20px;
`;

export const HotelTopSection = styled.div`
  margin-bottom: 16px;
  border-radius: 12px;
`;

export const HotelSection = styled.div`
  margin-bottom: 24px;
  background: linear-gradient(145deg, #ffffff 0%, #fafbfc 100%);
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(253, 102, 94, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(253, 102, 94, 0.15);
  }
`;

export const ThreeSectionContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const HotelInfoSection = styled.div`
  flex: 1;
  padding: 15px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #ffffff;
`;

export const FlightInfoSection = styled.div`
  flex: 1.5;
  padding: 15px;
  border-right: 1px solid #e0e0e0;
  background: #ffffff;
`;

export const PackageItemsSection = styled.div`
  flex: 1.2;
  padding: 15px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const PackageItemsHeader = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #1a237e;
  margin-bottom: 8px;
  line-height: 1.3;
`;

export const PackageItemsList = styled.div`
  flex: 1;

  div {
    font-size: 9px;
    color: #333;
    margin-bottom: 4px;
    line-height: 1.3;
  }
`;

export const HotelImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 25px rgba(253, 102, 94, 0.25);
  }
`;

export const HotelInfo = styled.div`
  padding-left: 15px;
`;

export const HotelName = styled.h3`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #1a237e;
  line-height: 1.3;
`;

export const HotelAddress = styled.div`
  font-size: 11px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const HotelDescription = styled.div`
  font-size: 11px;
  color: #333;
  line-height: 1.4;
  margin-bottom: 10px;
  text-align: justify;
`;

export const PackageDetailsLink = styled.a`
  color: #fd665e;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: inline-block;
  margin-top: 8px;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
    color: #e55a54;
  }
`;

export const FlightSection = styled.div`
  border: 1px solid rgba(253, 102, 94, 0.2);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  background: linear-gradient(145deg, #ffffff 0%, #fafbfc 100%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 25px rgba(253, 102, 94, 0.12);
  }
`;

export const HotelLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;

  span {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const StarRating = styled.div`
  span {
    font-size: 12px;
    margin-left: 2px;
  }
`;

export const HotelDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 12px;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const FlightTable = styled.div`
  margin-bottom: 15px;
`;

export const FlightRow = styled.div`
  display: grid;
  grid-template-columns: 25px 2fr 1fr 1fr;
  gap: 8px;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #e8e8e8;
  font-size: 10px;

  &:last-child {
    border-bottom: none;
  }
`;

export const FlightIcon = styled.div`
  font-size: 16px;
`;

export const FlightDetails = styled.div`
  div {
    margin-bottom: 2px;
  }
`;

export const FlightTimes = styled.div`
  text-align: center;

  div {
    margin-bottom: 2px;
  }
`;

export const FlightCodes = styled.div`
  text-align: center;

  div {
    margin-bottom: 2px;
  }
`;

export const PolicyCheckbox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 11px;

  input[type="checkbox"] {
    margin-top: 2px;
  }

  label {
    line-height: 1.3;
    cursor: pointer;
  }
`;

export const TabsSection = styled.div`
  margin-top: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  height: 60vh;

  .MuiTabs-root {
    min-height: 48px;
    background: #ffffff;
    border-bottom: 1px solid #e0e0e0;
  }

  .MuiTabs-scroller {
    overflow-x: auto !important;
  }

  .MuiTabs-flexContainer {
    overflow-x: auto;
  }

  .MuiTab-root {
    min-height: 48px;
    font-size: 14px;
    text-transform: none;
    color: #363636;
    font-weight: 500;
    transition: all 0.2s ease;
    padding: 12px 20px;

    &:hover {
      color: #fd665e;
      background: rgba(253, 102, 94, 0.05);
    }

    &.Mui-selected {
      color: #fd665e;
      font-weight: 600;
      background: rgba(253, 102, 94, 0.08);
    }
  }

  .MuiTabs-indicator {
    background-color: #fd665e;
    height: 3px;
  }
`;

export const TabContent = styled.div`
  padding: 30px;
  font-size: 14px;
  line-height: 1.6;
  background: #ffffff;
  flex: 1;
  overflow-y: auto;

  h4 {
    margin: 0 0 25px 0;
    font-size: 20px;
    color: #FD665E;
    font-weight: 600;
    padding-bottom: 12px;
    border-bottom: 2px solid #FD665E;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 60px;
      height: 2px;
      background: #FEC7C7;
    }
  }

  h5 {
    margin: 25px 0 15px 0;
    font-size: 16px;
    color: #FD665E;
    font-weight: 600;
    padding: 10px 0 10px 15px;
    border-left: 4px solid #FD665E;
    background: rgba(253, 102, 94, 0.08);
    border-radius: 0 4px 4px 0;
  }

  p {
    margin: 10px 0;
    padding: 5px 0;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(102, 126, 234, 0.03);
      padding: 8px 10px;
      border-radius: 4px;
    }
  }

  ul {
    margin: 12px 0;
    padding-left: 0;
    list-style: none;
  }

  li {
    margin: 8px 0;
    padding: 10px 15px;
    background: #f8f9fa;
    border-left: 3px solid #FD665E;
    border-radius: 4px;
    transition: all 0.2s ease;
    position: relative;

    &:before {
      content: '\2713';
      color: #FD665E;
      font-weight: bold;
      margin-right: 10px;
    }

    &:hover {
      background: rgba(253, 102, 94, 0.08);
      transform: translateX(3px);
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
  }

  strong {
    color: #363636;
    font-weight: 600;
  }
`;

export const PackageSidebar = styled.div`
  background: #f8f9fa;
  border-radius: 4px;
  padding: 15px;
`;

export const SidebarHeader = styled.div`
  background: #1a237e;
  color: white;
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 11px;
  margin-bottom: 15px;
  line-height: 1.3;
`;

export const SidebarContent = styled.div`
  div {
    margin-bottom: 6px;
    font-size: 10px;
    line-height: 1.3;

    strong {
      color: #1a237e;
      font-weight: 600;
    }
  }
`;

// Modal specific styles
export const ModalHeader = styled.div`
  background: #fd665e;
  color: white;
  padding: 24px 30px;
  position: relative;
  border-bottom: 3px solid #fec7c7;

  .title-container {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .icon {
    font-size: 28px;
    color: #ffffff;
  }

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.2;
  }

  .subtitle {
    font-size: 14px;
    opacity: 0.85;
    margin-top: 8px;
    font-weight: 400;
    line-height: 1.3;
    color: rgba(255, 255, 255, 0.9);
  }

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin: 20px 0;
`;

export const InfoCard = styled.div`
  background: white;
  padding: 18px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 15px rgba(253, 102, 94, 0.15);
    transform: translateY(-2px);
    border-color: #fd665e;
  }

  .label {
    font-size: 12px;
    color: #363636;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-bottom: 8px;
    font-weight: 500;
    opacity: 0.8;
  }

  .value {
    font-size: 15px;
    font-weight: 600;
    color: #363636;
    line-height: 1.3;
  }
`;

export const Timeline = styled.div`
  position: relative;
  padding-left: 35px;

  &:before {
    content: "";
    position: absolute;
    left: 12px;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom, #fd665e, #fec7c7);
  }
`;

export const TimelineItem = styled.div`
  position: relative;
  margin-bottom: 25px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;

  &:before {
    content: "${(props) => props.day || ""}";
    position: absolute;
    left: -28px;
    top: 20px;
    width: 24px;
    height: 24px;
    background: #fd665e;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    border: 3px solid white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  h5 {
    margin: 0 0 12px 0;
    color: #fd665e;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin: 6px 0;
    padding-left: 12px;
    border-left: 2px solid #fec7c7;
    color: #363636;
  }
`;

// Legacy components kept for compatibility
export const RoomSection = styled(FlightSection)``;
export const RoomTable = styled(FlightTable)``;
export const TableHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #1a237e;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 2px solid #1a237e;
`;
export const RoomRow = styled(FlightRow)``;
export const RoomIcon = styled(FlightIcon)``;
export const RoomDetails = styled(FlightDetails)``;
export const PriceDetails = styled(FlightTimes)``;
export const FinalPrice = styled(FlightCodes)``;

// Hotel Modal Styles
export const HotelModalHeader = styled.div`
  background: #fd665e;
  color: white;
  padding: 24px 30px;
  position: relative;
  border-bottom: 3px solid #fec7c7;

  .title-container {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .icon {
    font-size: 28px;
    color: #ffffff;
  }

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.2;
  }

  .subtitle {
    font-size: 14px;
    opacity: 0.85;
    margin-top: 8px;
    font-weight: 400;
    line-height: 1.3;
    color: rgba(255, 255, 255, 0.9);
  }

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }
  }
`;

export const HotelModalContent = styled.div`
  display: flex;
  gap: 24px;
  min-height: 450px;
  background: linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

export const HotelModalLeft = styled.div`
  flex: 0 0 150px;
  display: flex;
  align-items: flex-start;
`;

export const HotelModalLogo = styled.div`
  width: 140px;
  height: 110px;
  border: 2px solid rgba(253, 102, 94, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(253, 102, 94, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 25px rgba(253, 102, 94, 0.25);
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .hotel-placeholder {
    text-align: center;
    background: linear-gradient(135deg, #fd665e 0%, #ff8a80 100%);
    color: white;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      font-size: 28px;
      font-weight: bold;
      line-height: 1;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    small {
      font-size: 12px;
      margin-top: 4px;
      opacity: 0.9;
    }
  }
`;

export const HotelModalCenter = styled.div`
  flex: 1;
  padding-right: 20px;
`;

export const HotelModalName = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #fd665e;
  margin: 0 0 12px 0;
  line-height: 1.2;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const HotelModalAddress = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 16px;
  line-height: 1.4;
`;

export const HotelModalDescription = styled.div`
  margin-bottom: 20px;

  strong {
    font-size: 14px;
    color: #333;
    display: block;
    margin-bottom: 8px;
  }

  p {
    font-size: 12px;
    color: #555;
    line-height: 1.4;
    margin: 0;
    text-align: justify;
  }
`;

export const HotelModalConditions = styled.div`
  .condition-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 12px;
  }
`;

export const HotelConditionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  background: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &.selected {
    background: rgba(253, 102, 94, 0.08);
    border-color: #fd665e;
    box-shadow: 0 4px 15px rgba(253, 102, 94, 0.15);
    transform: translateY(-1px);
  }

  &:hover {
    background: rgba(253, 102, 94, 0.04);
    border-color: #fd665e;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(253, 102, 94, 0.1);
  }

  input[type="radio"] {
    margin-right: 12px;
    accent-color: #fd665e;
    transform: scale(1.2);
  }
  .accomodation-container {
    display: flex;
    flex-direction: row;
    gap: 2px;
  }

  .accommodation-type {
    color: #363636;
    font-weight: 500;
  }

  .accomodation-title {
    display: flex;
    flex-direction: column;
  }

  .accomodation-description {
    font-size: 12px;
    color: #adaaaaff;
  }

  .price {
    font-weight: bold;
    color: #fd665e;
    font-size: 14px;
  }
`;

export const HotelModalRight = styled.div`
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HotelModalPriceInfo = styled.div`
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid rgba(253, 102, 94, 0.2);
  border-radius: 12px;
  padding: 20px;
  text-align: right;
  box-shadow: 0 4px 15px rgba(253, 102, 94, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(253, 102, 94, 0.15);
  }

  .total-label {
    font-size: 16px;
    color: #363636;
    margin-bottom: 8px;

    strong {
      font-size: 18px;
      color: #fd665e;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
  }

  .taxes-info {
    font-size: 12px;
    color: #666;
    margin-bottom: 6px;
  }

  .per-person {
    font-size: 12px;
    color: #666;
    font-weight: 500;
  }
`;

export const HotelModalPhotosButton = styled.button`
  background: linear-gradient(135deg, #fd665e 0%, #ff8a80 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(253, 102, 94, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(253, 102, 94, 0.4);
    background: linear-gradient(135deg, #e55a54 0%, #ff8a80 100%);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const HotelModalGallery = styled.div`
  border: 2px solid rgba(253, 102, 94, 0.2);
  border-radius: 12px;
  overflow: hidden;
  background: #f0f0f0;
  height: 140px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(253, 102, 94, 0.1);

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 25px rgba(253, 102, 94, 0.2);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
`;
